import React from "react";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";

import summaryProgress from "../../../../images/summary_progress.svg";

/**
 * Component shown during LOADING state when restarting RTMS
 */
const SummarizeRestarting = () => {
  return (
    <Column alignment="start" width="100%" spacing="none" spacingInset="none">
      <Column height="34px" spacing="none" />
      <Row spacing="none" spacingInset="none">
        <Column width="15px" />
        <img src={summaryProgress} alt="" />
      </Row>
      <Column height="16px" spacing="none" />
      <Column spacing="none" spacingInset="none">
        <Row spacing="none" spacingInset="none">
          <Column width="68px" />
          <Text type="h50" alignment="start">
            Restarting - up to 1 min
          </Text>
        </Row>
      </Column>
    </Column>
  );
};

export default SummarizeRestarting;
